<template>
  <div
    class="min-h-screen pb-4 grid grid-rows-[auto_1fr] bg-pitch-black text-total-white"
  >
    <!-- Top Header with Mason Logo -->
    <div
      class="flex w-full justify-between items-center px-4 p-3 border-b border-prime-golden bg-pitch-black-900"
    >
      <a href="/" class="text-prime-golden font-avenir-medium"
        ><img
         class="w-24 h-24 -my-8 -ml-[10px]"

          src="@/assets/images/mason-logo.svg"
          alt="Mason Logo"
      /></a>
    </div>

    <!-- Main Content Section -->
    <div
      class="w-full pt-6 flex flex-col gap-10 justify-center items-center mx-auto max-w-md px-4"
    >
      <div class="mb-6 text-center">
        <h1 class="text-3xl font-bold mb-4" v-if="isSuccess">Email Account Linked!</h1>
        <h1 class="text-3xl font-bold mb-4" v-else-if="isLoading">
          Please wait while we link your email account.
        </h1>
        <h1 class="text-3xl font-bold mb-4" v-else>Error Linking Email Account</h1>
        <p class="text-sm text-total-white-500">
          <template v-if="isSuccess">
            We have successfully linked your email account to your Mason account.
          </template>
          <template v-else-if="isLoading">
            Please wait while we link your email account.
          </template>
          <template v-else>
            There was a problem while linking the account. Please try again later.
          </template>
        </p>
      </div>
      <p class="text-total-white-700" v-if="isSuccess">
        Redirecting you to the home page...
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import authService from "@/api/authService";
import { useAuthStore } from "@/stores/auth";

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const isLoading = ref(true);
const isSuccess = ref(false);

onMounted(async () => {
  const code = route.query.code;
  const state = route.query.state;
  const errorParam = route.query.error;

  const path = route.path;

  if (errorParam === "true") {
    // Error occurred during authorization URL retrieval
    isLoading.value = false;
    isSuccess.value = false;
  } else if (code && state) {
    try {
      if (path === "/gmail-success") {
        const response = await authService.completeGmailAuthorization(code, state);
        if (!response.data.error) {
          isSuccess.value = true;
          authStore.setGmailAuthorized();
        }
      } else if (path === "/outlook-success") {
        const response = await authService.completeOutlookAuthorization(code, state);
        if (!response.data.error) {
          isSuccess.value = true;
          authStore.setOutlookAuthorized();
        }
      }

      authStore.verificationAndAuthorizationValuesExist = false;

      // Redirect after a delay
      setTimeout(() => {
        router.push({ name: "ProjectsPage" });
      }, 3000);
    } catch (error) {
      console.error("Error completing Gmail authorization:", error);
      isSuccess.value = false;
    } finally {
      isLoading.value = false;
    }
  } else {
    // No code or state present, handle the error
    isLoading.value = false;
    isSuccess.value = false;
  }
});
</script>

<style scoped>
/* Existing styles */
</style>
